import store from "@/store";

export const unitMapper = {
  productInvToProd(value, data) {
    const qty_inv = data.quantity_inventory;
    const qty_prod = data.quantity_production;
    return (value / qty_inv) * qty_prod;
  },
  productProdToInv(value, data, is_alt = false) {
    if (is_alt === true) {
      const qty_inv = data.alternative_quantity_inventory;
      const qty_prod = data.alternative_quantity_production;
      return (value * qty_inv) / qty_prod;
    } else {
      const qty_inv = data.quantity_inventory;
      const qty_prod = data.quantity_production;
      return (value * qty_inv) / qty_prod;
    }
  },
  productInvToOrder(value, data) {
    const qty_inv_order = data.quantity_inventory_order;
    const qty_order = data.quantity_order;
    return value / (qty_order * qty_inv_order);
  },
  productOrderToInv(value, data) {
    if (data.use_order_quantity === true) {
      const qty_inv_order = data.quantity_inventory_order;
      const qty_order = data.quantity_order;
      return (value * qty_inv_order) / qty_order;
    } else {
      return value;
    }
  },
  productGetInvUnit(item) {
    if (item.data) {
      return item.data.unite_mesure_inventory
        ? item.data.unite_mesure_inventory
        : null;
    } else {
      return null;
    }
  },
  productGetNewInvPrice(data) {
    const qty_inv_order = data.quantity_inventory_order;
    const qty_order = data.quantity_order;
    const price_order = data.price_order;

    return (price_order * qty_order) / qty_inv_order;
  },
  productGetProdUnit(item) {
    if (item.data) {
      return item.data.unite_mesure ? item.data.unite_mesure : "undefined";
    } else {
      return null;
    }
  },
  isCustomUnit(unit) {
    return store.getters.getCustomUnitsValues.includes(unit) || unit === null;
  },
  recipeInvToProd(value, recipe, data) {
    const qty_inv = data.quantity_inventory;
    const qty_prod = data.quantity_production;
    return (value / qty_inv) * qty_prod;
  },
  recipeProdToInv(value, recipe, data) {
    const qty_inv = data.quantity_inventory;
    const qty_prod = data.quantity_production;
    return (value * qty_inv) / qty_prod;
  },
  recipeNumberOfRecipe(value, recipe) {
    return value / recipe.quantite_produite;
  },
  recipeGetInvUnit(item) {
    if (item.data) {
      return item.data.unite_inventory
        ? item.data.unite_inventory
        : item.unite_produite;
    } else {
      return item.unite_produite;
    }
  },
  recipeProdPriceToInvPrice(value, recipe, data) {
    if (data.quantity_production) {
      const qty_prod = data.quantity_production;
      const price_inv = data.prix_inventory;
      const price_prod = data.cost;

      const value_in_prod_unit = (value / price_prod) * qty_prod;
      const qty_in_inv_unit = this.recipeProdToInv(
        value_in_prod_unit,
        recipe,
        data
      );

      return qty_in_inv_unit * price_inv;
    } else {
      return data.cost;
    }
  }
};
